
import React, { useEffect, useState } from "react";

const Footer = () => {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowTop(window.scrollY > 350);
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const goTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <>
      <style>{`

        /* =========================================================
           STUDENT SCHOOL DARPAN
           PREMIUM + CLEAR FOOTER
        ========================================================= */

        .ssd-footer,
        .ssd-footer * {
          box-sizing: border-box;
        }

        .ssd-footer {
          position: relative;
          overflow: hidden;

          width: 100%;

          color: #ffffff;

          background:
            radial-gradient(
              circle at 0% 0%,
              rgba(37, 99, 235, 0.25),
              transparent 30%
            ),
            radial-gradient(
              circle at 100% 100%,
              rgba(124, 58, 237, 0.22),
              transparent 32%
            ),
            #020617;

          font-family:
            Inter,
            "Plus Jakarta Sans",
            system-ui,
            -apple-system,
            BlinkMacSystemFont,
            "Segoe UI",
            sans-serif;
        }

        /* =========================================================
           TOP LINE
        ========================================================= */

        .ssd-footer-top {
          width: 100%;
          height: 5px;

          background:
            linear-gradient(
              90deg,
              #2563eb,
              #4f46e5,
              #7c3aed,
              #06b6d4,
              #2563eb
            );

          background-size: 300% 100%;

          animation:
            ssdGradient 8s linear infinite;
        }

        @keyframes ssdGradient {
          0% {
            background-position: 0% 50%;
          }

          100% {
            background-position: 300% 50%;
          }
        }

        /* =========================================================
           BACKGROUND GRID
        ========================================================= */

        .ssd-footer::before {
          content: "";

          position: absolute;

          inset: 0;

          background-image:
            linear-gradient(
              rgba(255, 255, 255, 0.025) 1px,
              transparent 1px
            ),
            linear-gradient(
              90deg,
              rgba(255, 255, 255, 0.025) 1px,
              transparent 1px
            );

          background-size:
            50px 50px;

          pointer-events: none;
        }

        /* =========================================================
           CONTAINER
        ========================================================= */

        .ssd-footer-container {
          position: relative;

          z-index: 2;

          width:
            min(
              1280px,
              calc(100% - 50px)
            );

          margin:
            0 auto;
        }

        /* =========================================================
           MAIN GRID
        ========================================================= */

        .ssd-footer-main {
          display: grid;

          grid-template-columns:
            1.7fr
            1fr
            1fr
            1fr;

          gap: 65px;

          padding:
            75px 0 55px;
        }

        /* =========================================================
           BRAND
        ========================================================= */

        .ssd-brand {
          min-width: 0;
        }

        .ssd-brand-logo {
          display: flex;

          align-items: center;

          gap: 16px;
        }

        /* LOGO */

        .ssd-logo-box {
          position: relative;

          width: 62px;
          height: 62px;

          flex-shrink: 0;

          display: flex;

          align-items: center;
          justify-content: center;

          border-radius: 18px;

          background:
            linear-gradient(
              135deg,
              #2563eb,
              #4f46e5,
              #7c3aed
            );

          box-shadow:
            0 15px 40px
            rgba(37, 99, 235, 0.35);

          overflow: hidden;
        }

        .ssd-logo-box svg {
          width: 46px;
          height: 46px;

          position: relative;

          z-index: 2;
        }

        /* BRAND NAME */

        .ssd-brand-name {
          margin: 0;

          color: #ffffff !important;

          font-size: 28px;

          line-height: 1.2;

          font-weight: 850;

          letter-spacing: -0.7px;
        }

        /* TAGLINE */

        .ssd-brand-tagline {
          display: block;

          margin-top: 7px;

          color: #93c5fd !important;

          font-size: 11px;

          line-height: 1.4;

          font-weight: 800;

          letter-spacing: 1.2px;
        }

        /* DESCRIPTION */

        .ssd-brand-description {
          max-width: 520px;

          margin:
            25px 0 0;

          color: #d1d5db !important;

          font-size: 15px;

          line-height: 1.9;

          font-weight: 450;
        }

        /* =========================================================
           SOCIAL
        ========================================================= */

        .ssd-social {
          display: flex;

          align-items: center;

          gap: 11px;

          margin-top: 27px;
        }

        .ssd-social a {
          width: 43px;
          height: 43px;

          display: flex;

          align-items: center;
          justify-content: center;

          border:
            1px solid
            rgba(255, 255, 255, 0.15);

          border-radius: 13px;

          color: #dbeafe !important;

          background:
            rgba(255, 255, 255, 0.06);

          text-decoration: none;

          font-size: 15px;

          font-weight: 800;

          transition:
            all 0.25s ease;
        }

        .ssd-social a:hover {
          color: #ffffff !important;

          background:
            linear-gradient(
              135deg,
              #2563eb,
              #6366f1
            );

          border-color:
            transparent;

          transform:
            translateY(-5px);

          box-shadow:
            0 12px 30px
            rgba(37, 99, 235, 0.35);
        }

        /* =========================================================
           COLUMN
        ========================================================= */

        .ssd-column {
          min-width: 0;
        }

        .ssd-column-title {
          display: flex;

          align-items: center;

          gap: 11px;

          margin-bottom: 24px;
        }

        .ssd-title-bar {
          width: 4px;
          height: 25px;

          flex-shrink: 0;

          border-radius: 10px;

          background:
            linear-gradient(
              180deg,
              #60a5fa,
              #8b5cf6
            );

          box-shadow:
            0 0 15px
            rgba(96, 165, 250, 0.35);
        }

        .ssd-column-title h3 {
          margin: 0;

          color: #ffffff !important;

          font-size: 18px;

          line-height: 1.3;

          font-weight: 850;

          letter-spacing: -0.2px;
        }

        /* =========================================================
           LINKS
        ========================================================= */

        .ssd-links {
          display: flex;

          flex-direction: column;

          gap: 14px;

          margin: 0;

          padding: 0;

          list-style: none;
        }

        .ssd-links a {
          display: flex;

          align-items: center;

          width: fit-content;

          color: #d1d5db !important;

          text-decoration: none;

          font-size: 15px;

          line-height: 1.55;

          font-weight: 550;

          transition:
            all 0.25s ease;
        }

        .ssd-links a::before {
          content: "›";

          margin-right: 9px;

          color: #60a5fa !important;

          font-size: 20px;

          line-height: 1;

          font-weight: 700;

          transition:
            all 0.25s ease;
        }

        .ssd-links a:hover {
          color: #ffffff !important;

          transform:
            translateX(5px);
        }

        .ssd-links a:hover::before {
          color: #93c5fd !important;

          transform:
            translateX(2px);
        }

        /* =========================================================
           CONTACT AREA
        ========================================================= */

        .ssd-contact {
          display: grid;

          grid-template-columns:
            repeat(3, 1fr);

          gap: 18px;

          padding: 24px;

          border:
            1px solid
            rgba(255, 255, 255, 0.10);

          border-radius: 20px;

          background:
            rgba(255, 255, 255, 0.045);

          backdrop-filter:
            blur(15px);

          -webkit-backdrop-filter:
            blur(15px);
        }

        .ssd-contact-item {
          display: flex;

          align-items: center;

          gap: 14px;

          padding: 8px;
        }

        .ssd-contact-icon {
          width: 45px;
          height: 45px;

          flex-shrink: 0;

          display: flex;

          align-items: center;
          justify-content: center;

          border-radius: 13px;

          color: #93c5fd;

          background:
            rgba(37, 99, 235, 0.12);

          border:
            1px solid
            rgba(96, 165, 250, 0.16);
        }

        .ssd-contact-icon svg {
          width: 21px;
          height: 21px;
        }

        .ssd-contact-label {
          display: block;

          color: #94a3b8;

          font-size: 10px;

          font-weight: 800;

          text-transform: uppercase;

          letter-spacing: 1px;
        }

        .ssd-contact-text {
          display: block;

          margin-top: 5px;

          color: #e2e8f0;

          font-size: 13px;

          font-weight: 650;
        }

        /* =========================================================
           BOTTOM
        ========================================================= */

        .ssd-footer-bottom {
          display: grid;

          grid-template-columns:
            1fr auto 1fr;

          align-items: center;

          gap: 25px;

          padding:
            28px 0 26px;

          margin-top: 38px;

          border-top:
            1px solid
            rgba(255, 255, 255, 0.10);

          color: #cbd5e1 !important;

          font-size: 13px;

          line-height: 1.5;
        }

        .ssd-copyright {
          color: #cbd5e1 !important;

          font-size: 13px;

          font-weight: 500;
        }

        .ssd-copyright strong {
          color: #ffffff !important;

          font-weight: 800;
        }

        /* =========================================================
           BOTTOM LINKS
        ========================================================= */

        .ssd-bottom-links {
          display: flex;

          align-items: center;

          justify-content: center;

          gap: 13px;
        }

        .ssd-bottom-links a {
          color: #cbd5e1 !important;

          text-decoration: none;

          font-size: 13px;

          font-weight: 600;

          transition:
            all 0.2s ease;
        }

        .ssd-bottom-links a:hover {
          color: #ffffff !important;
        }

        .ssd-separator {
          width: 4px;
          height: 4px;

          flex-shrink: 0;

          border-radius: 50%;

          background:
            #64748b;
        }

        /* =========================================================
           MADE WITH
        ========================================================= */

        .ssd-made {
          text-align: right;

          color: #cbd5e1 !important;

          font-size: 13px;

          font-weight: 500;
        }

        .ssd-heart {
          color: #fb7185 !important;

          margin:
            0 4px;

          font-size: 16px;
        }

        /* =========================================================
           BACK TO TOP
        ========================================================= */

        .ssd-back-top {
          position: fixed;

          right: 24px;

          bottom: 88px;

          z-index: 9998;

          width: 47px;
          height: 47px;

          display: flex;

          align-items: center;
          justify-content: center;

          border:
            1px solid
            rgba(255,255,255,.18);

          border-radius: 14px;

          color: #ffffff;

          background:var(--nv-dark-bg);

          cursor: pointer;

          opacity: 0;

          visibility: hidden;

          transform:
            translateY(12px);

          transition:
            all .3s ease;

          box-shadow:
            0 10px 28px
            rgba(3,169,244,.30);
        }

        .ssd-back-top.show {
          opacity: 1;

          visibility: visible;

          transform:
            translateY(0);
        }

        .ssd-back-top:hover {
          background:
            linear-gradient(
              135deg,
              #2563eb,
              #6366f1
            );

          transform:
            translateY(-4px);

          box-shadow:
            0 15px 35px
            rgba(37,99,235,.38);
        }

        .ssd-back-top svg {
          width: 20px;
          height: 20px;
        }

        /* =========================================================
           WHATSAPP
        ========================================================= */

        .ssd-whatsapp {
          position: fixed;

          right: 20px;

          bottom: 20px;

          z-index: 9999;

          width: 57px;
          height: 57px;

          display: flex;

          align-items: center;
          justify-content: center;

          border-radius: 50%;

          color: #ffffff;

          background:
            linear-gradient(
              135deg,
              #16a34a,
              #22c55e
            );

          text-decoration: none;

          box-shadow:
            0 12px 32px
            rgba(34,197,94,.40);

          transition:
            all .3s ease;
        }

        .ssd-whatsapp:hover {
          transform:
            translateY(-5px)
            scale(1.06);

          box-shadow:
            0 18px 42px
            rgba(34,197,94,.50);
        }

        .ssd-whatsapp svg {
          width: 28px;
          height: 28px;
        }

        /* =========================================================
           TABLET
        ========================================================= */

        @media (max-width: 1050px) {

          .ssd-footer-main {
            grid-template-columns:
              1.5fr 1fr 1fr;

            gap: 45px;
          }

          .ssd-brand {
            grid-column:
              1 / -1;
          }

          .ssd-brand-description {
            max-width:
              750px;
          }

          .ssd-contact {
            grid-template-columns:
              1fr;
          }
        }

        /* =========================================================
           MOBILE
        ========================================================= */

        @media (max-width: 700px) {

          .ssd-footer-container {
            width:
              calc(100% - 30px);
          }

          .ssd-footer-main {
            grid-template-columns:
              1fr 1fr;

            gap:
              40px 25px;

            padding:
              50px 0 35px;
          }

          .ssd-brand {
            grid-column:
              1 / -1;
          }

          .ssd-logo-box {
            width: 56px;
            height: 56px;

            border-radius: 16px;
          }

          .ssd-logo-box svg {
            width: 41px;
            height: 41px;
          }

          .ssd-brand-name {
            font-size: 23px;
          }

          .ssd-brand-tagline {
            font-size: 9px;

            letter-spacing:
              .8px;
          }

          .ssd-brand-description {
            margin-top: 20px;

            color: #d1d5db !important;

            font-size: 14px;

            line-height: 1.8;
          }

          .ssd-social {
            margin-top: 22px;
          }

          .ssd-social a {
            width: 41px;
            height: 41px;
          }

          .ssd-column-title {
            margin-bottom: 19px;
          }

          .ssd-title-bar {
            width: 4px;
            height: 21px;
          }

          .ssd-column-title h3 {
            font-size: 16px;
          }

          .ssd-links {
            gap: 13px;
          }

          .ssd-links a {
            color: #d1d5db !important;

            font-size: 14px;

            font-weight: 550;
          }

          .ssd-links a::before {
            color: #60a5fa !important;

            font-size: 18px;
          }

          .ssd-footer-bottom {
            grid-template-columns:
              1fr;

            text-align:
              center;

            gap: 14px;

            padding:
              22px 0;
          }

          .ssd-copyright {
            font-size: 12px;
          }

          .ssd-bottom-links {
            justify-content:
              center;
          }

          .ssd-bottom-links a {
            font-size: 12px;
          }

          .ssd-made {
            text-align:
              center;

            font-size: 12px;
          }

          .ssd-whatsapp {
            width: 52px;
            height: 52px;

            right: 14px;
            bottom: 14px;
          }

          .ssd-back-top {
            width: 42px;
            height: 42px;

            right: 18px;
            bottom: 77px;
          }
        }

        /* =========================================================
           SMALL MOBILE
        ========================================================= */

        @media (max-width: 430px) {

          .ssd-footer-container {
            width:
              calc(100% - 24px);
          }

          .ssd-footer-main {
            grid-template-columns:
              1fr;

            gap: 35px;
          }

          .ssd-brand {
            grid-column:
              auto;
          }

          .ssd-brand-name {
            font-size: 21px;
          }

          .ssd-brand-tagline {
            font-size: 8px;
          }

          .ssd-brand-description {
            color: #d1d5db !important;

            font-size: 13px;
          }

          .ssd-column-title h3 {
            font-size: 16px;
          }

          .ssd-links a {
            color: #d1d5db !important;

            font-size: 14px;
          }
        }

        /* =========================================================
           ACCESSIBILITY
        ========================================================= */

        .ssd-links a:focus-visible,
        .ssd-social a:focus-visible,
        .ssd-bottom-links a:focus-visible,
        .ssd-whatsapp:focus-visible,
        .ssd-back-top:focus-visible {

          outline:
            2px solid #60a5fa;

          outline-offset:
            3px;
        }

      `}</style>

      {/* =========================================================
          FOOTER
      ========================================================= */}

      <footer className="ssd-footer">

        {/* TOP LINE */}

        <div className="ssd-footer-top"></div>

        <div className="ssd-footer-container">

          {/* =====================================================
              MAIN FOOTER
          ===================================================== */}

          <div className="ssd-footer-main">

            {/* =================================================
                BRAND
            ================================================= */}

            <div className="ssd-brand">

              <div className="ssd-brand-logo">

                <div className="ssd-logo-box">

                  <svg
                    viewBox="0 0 64 64"
                    fill="none"
                    aria-hidden="true"
                  >

                    <rect
                      x="7"
                      y="7"
                      width="50"
                      height="50"
                      rx="16"
                      fill="rgba(255,255,255,.12)"
                    />

                    <path
                      d="M19 23.5L32 17L45 23.5L32 30L19 23.5Z"
                      fill="white"
                    />

                    <path
                      d="M23 28V36.5C23 39.5 27 42 32 42C37 42 41 39.5 41 36.5V28"
                      stroke="white"
                      strokeWidth="2.8"
                      strokeLinecap="round"
                    />

                    <path
                      d="M45 24V34"
                      stroke="white"
                      strokeWidth="2.8"
                      strokeLinecap="round"
                    />

                    <circle
                      cx="45"
                      cy="37.5"
                      r="2.3"
                      fill="white"
                    />

                  </svg>

                </div>

                <div>

                  <h2 className="ssd-brand-name">
                    Student School Darpan
                  </h2>

                  <span className="ssd-brand-tagline">
                    SMART • SIMPLE • DIGITAL EDUCATION
                  </span>

                </div>

              </div>

              <p className="ssd-brand-description">
                A modern digital education platform connecting
                students, parents, teachers and schools through
                one smart ecosystem. Simplifying education,
                communication and school management through
                technology.
              </p>

              {/* SOCIAL */}

              <div className="ssd-social">

                <a
                  href="https://facebook.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                >
                  f
                </a>

                <a
                  href="https://instagram.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Instagram"
                >
                  ◎
                </a>

                <a
                  href="https://linkedin.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="LinkedIn"
                >
                  in
                </a>

                <a
                  href="https://youtube.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="YouTube"
                >
                  ▶
                </a>

              </div>

            </div>

            {/* =================================================
                PLATFORM
            ================================================= */}

            <div className="ssd-column">

              <div className="ssd-column-title">

                <span className="ssd-title-bar"></span>

                <h3>
                  Platform
                </h3>

              </div>

              <div className="ssd-links">

                <a href="/">
                  Home
                </a>

                <a href="https://eduadmin.sindoor7.com/school">
                  Schools
                </a>

                <a href="/dashboard">
                  Students
                </a>

                <a href="https://eduadmin.sindoor7.com/teachern">
                  Teachers
                </a>

                <a href="//School-Report">
                  Reports
                </a>

              </div>

            </div>

            {/* =================================================
                SERVICES
            ================================================= */}

            <div className="ssd-column">

              <div className="ssd-column-title">

                <span className="ssd-title-bar"></span>

                <h3>
                  Services
                </h3>

              </div>

              <div className="ssd-links">

                <a href="/Attendance">
                  Attendance
                </a>

                <a href="/PageResults">
                  Results
                </a>

                <a href="FeeManagement">
                  Fee Management
                </a>

                <a href="/School-Report">
                  School Management
                </a>

                <a href="/ContactUs">
                  Communication
                </a>

              </div>

            </div>

            {/* =================================================
                SUPPORT
            ================================================= */}

            <div className="ssd-column">

              <div className="ssd-column-title">

                <span className="ssd-title-bar"></span>

                <h3>
                  Support
                </h3>

              </div>

              <div className="ssd-links">

                <a href="/ContactUs">
                  Contact Us
                </a>

                <a href="/FAQs">
                  FAQs
                </a>

                <a href="/PrivacyPolicy">
                  Privacy Policy
                </a>

                <a href="/terms">
                  Terms & Conditions
                </a>

                <a href="#help">
                  Help Center
                </a>

              </div>

            </div>

          </div>

          {/* =====================================================
              BOTTOM FOOTER
          ===================================================== */}

          <div className="ssd-footer-bottom">

            <div className="ssd-copyright">

              © {new Date().getFullYear()}{" "}

              <strong>
                Student School Darpan
              </strong>

              . All rights reserved.

            </div>

            <div className="ssd-bottom-links">

              <a href="/PrivacyPolicy">
                Privacy
              </a>

              <span className="ssd-separator"></span>

              <a href="/terms">
                Terms
              </a>

              <span className="ssd-separator"></span>

              <a href="#cookies">
                Cookies
              </a>

            </div>

            <div className="ssd-made">

              Made with

              <span className="ssd-heart">
                ♥
              </span>

              for Education

            </div>

          </div>

        </div>

      </footer>

      {/* =========================================================
          WHATSAPP
      ========================================================= */}

      <a
        href="https://wa.me/919999999999"
        target="_blank"
        rel="noopener noreferrer"
        className="ssd-whatsapp"
        aria-label="Chat with us on WhatsApp"
      >

        <svg
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
        >

          <path
            d="M20 11.5C20 16.19 16.19 20 11.5 20C9.97 20 8.54 19.6 7.3 18.9L4 20L5.1 16.9C4.4 15.65 4 14.15 4 12.5C4 7.81 7.81 4 12.5 4C17.19 4 20 7.81 20 11.5Z"
            stroke="currentColor"
            strokeWidth="1.7"
          />

          <path
            d="M8.5 9.5C8.5 12.2 10.4 14.7 13.1 15.6C14 15.9 14.8 15.6 15.3 14.8L15.7 14.1L13.9 13.2L13.2 14.1C11.9 13.6 10.9 12.6 10.4 11.3L11.3 10.6L10.4 8.8L9.7 9.2C8.9 9.7 8.5 9.5 8.5 9.5Z"
            fill="currentColor"
          />

        </svg>

      </a>

      {/* =========================================================
          BACK TO TOP
      ========================================================= */}

      <button
        type="button"
        className={`ssd-back-top ${
          showTop ? "show" : ""
        }`}
        onClick={goTop}
        aria-label="Back to top"
      >

        <svg
          viewBox="0 0 24 24"
          fill="none"
          aria-hidden="true"
        >

          <path
            d="M12 19V5"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />

          <path
            d="M6 11L12 5L18 11"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />

        </svg>

      </button>

    </>
  );
};

export default Footer;

